/**
 * @generated SignedSource<<7cd56564558c3acb2beb7f46f2662b9a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type actionWarenannahmeQuery$variables = {
  hubName: string;
};
export type actionWarenannahmeQuery$data = {
  readonly hubMeta: {
    readonly id: string;
    readonly organization: {
      readonly id: string;
    };
    readonly serviceProviders: ReadonlyArray<{
      readonly id: string;
    }>;
  };
};
export type actionWarenannahmeQuery = {
  response: actionWarenannahmeQuery$data;
  variables: actionWarenannahmeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hubName"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*:: as any*/)
],
v3 = {
  "alias": null,
  "args": [
    {
      "fields": [
        {
          "kind": "Variable",
          "name": "name",
          "variableName": "hubName"
        }
      ],
      "kind": "ObjectValue",
      "name": "by"
    }
  ],
  "concreteType": "HubMeta",
  "kind": "LinkedField",
  "name": "hubMeta",
  "plural": false,
  "selections": [
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": (v2/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "serviceProviders",
      "plural": true,
      "selections": (v2/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "enumValues": null,
  "nullable": false,
  "plural": false,
  "type": "UUID"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "actionWarenannahmeQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v3/*:: as any*/),
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "actionWarenannahmeQuery",
    "selections": [
      (v3/*:: as any*/)
    ]
  },
  "params": {
    "cacheID": "1e8e8e1585b1433e0746f4ae0fe9c4f9",
    "id": null,
    "metadata": {
      "relayTestingSelectionTypeInfo": {
        "hubMeta": {
          "enumValues": null,
          "nullable": true,
          "plural": false,
          "type": "HubMeta"
        },
        "hubMeta.id": (v4/*:: as any*/),
        "hubMeta.organization": {
          "enumValues": null,
          "nullable": false,
          "plural": false,
          "type": "Organization"
        },
        "hubMeta.organization.id": (v4/*:: as any*/),
        "hubMeta.serviceProviders": {
          "enumValues": null,
          "nullable": false,
          "plural": true,
          "type": "Organization"
        },
        "hubMeta.serviceProviders.id": (v4/*:: as any*/)
      }
    },
    "name": "actionWarenannahmeQuery",
    "operationKind": "query",
    "text": "query actionWarenannahmeQuery(\n  $hubName: String!\n) {\n  hubMeta(by: {name: $hubName}) {\n    id\n    organization {\n      id\n    }\n    serviceProviders {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7700b6d0686129b5c1c1b2ab5c9a8efb";

export default node;
